export function toLocaleLowerCaseNoun(str: string, locale: string): string {
	return locale === 'de' ? str : str.toLowerCase();
}
